import { TeachersToolkitTraining } from "./TeachersToolkit/TeachersToolkitTraining/TeachersToolkitTraining";
import { SolarSchoolsTheme } from "./utilities/Theme/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import ReactDOM from "react-dom";
import React from "react";

const init = (api) => {
  const element = document.getElementById("teachers-toolkit-training");

  if (!element) {
    return;
  }

  document.title = `Teachers Toolkit - Training`;
  ReactDOM.render(
    <ThemeProvider theme={SolarSchoolsTheme}>
      <TeachersToolkitTraining />
    </ThemeProvider>,
    element
  );
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/teachersToolkitTraining.js